import { COOKIES } from '../constants';

const setUserCookie = (query, res) => {
  const cookieMaxAge = 60 * 60 * 24 * 10; // cookie lifetime 10 days
  const { displayName, email } = query || {};

  const getDetail = detail => (Array.isArray(detail) ? detail.shift() : detail);

  if (displayName && email) {
    const lsUser = {
      displayName: getDetail(displayName),
      email: getDetail(email),
    };

    res.cookie(COOKIES.LS_USER, JSON.stringify(lsUser), {
      maxAge: cookieMaxAge,
      httpOnly: true,
    });

    return lsUser;
  }

  return null;
};

export default setUserCookie;
